/**
 * Route for `gamification`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GamificationPage } from "../features/gamification/GamificationPage";

export const gamificationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/gamification",
	component: GamificationPage,
});

export default gamificationRoute;
